(function () {
  window.dataLayer = window.dataLayer || [];

  // ✅ Exit if not a product page
  if (!window.meta || !window.meta.product) return;

  // ✅ Exit if no variant selector exists
  function getVariantInput() {
    return document.querySelector('form[action*="/cart"] [name="id"]');
  }

  if (!getVariantInput()) return;
  let lastVariantId = null;

  function pushFormatEvent(variantId) {
    if (!variantId || variantId === lastVariantId) return;

    lastVariantId = variantId;

    const eventData = {
      event: "loverse_format_selected",
      product_id: window.meta?.product?.id || null,
    }
    window.dataLayer.push(eventData);
    console.log("🔥 loverse_format_selected:", eventData);
  }

  // ✅ Page Load (wait until variant is ready)
  document.addEventListener("DOMContentLoaded", function () {
    let attempts = 0;

    const interval = setInterval(function () {
      const input = getVariantInput();

      if (input && input.value) {
        pushFormatEvent(input.value);
        clearInterval(interval);
      }

      attempts++;
      if (attempts > 10) clearInterval(interval); // stop after ~2s
    }, 200);
  });

  // ✅ Variant Change (generic fallback)
  document.addEventListener("change", function (e) {
    const input = e.target.closest('form[action*="/cart"] [name="id"]');

    if (input && input.value) {
      pushFormatEvent(input.value);
    }
  });

  // ✅ Shopify Dawn/Studio event (best)
  document.addEventListener("variant:change", function (event) {
    const variant = event.detail && event.detail.variant;

    if (variant && variant.id) {
      pushFormatEvent(variant.id);
    }
  });

})();